import { actionCreatorFactory } from 'typescript-fsa';
import { DesignSet, ArrowType, OrderType, RecommendDesignItems } from '@app/react/const/type';

const actionCreator = actionCreatorFactory();

export interface ISetPartsSelectParam {
    arrowType: ArrowType;
    orderType: OrderType;
    item: DesignSet & RecommendDesignItems;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ISetPartsSelectResult {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ISetPartsSelectError {}

export const setPartsSelectAction = actionCreator.async<
ISetPartsSelectParam,
ISetPartsSelectResult,
ISetPartsSelectError
>('setPartsSelectAction');
